import { clusterApiUrl, Connection, PublicKey, Transaction, TransactionInstruction } from '@solana/web3.js';

export const MEMO_PROGRAM_ID = 'MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr';

export const signMigrationMemo = async ({ signTransaction, publicKey, message }) => {
    if (!signTransaction || !publicKey) {
        throw new Error('This wallet cannot sign the migration request');
    }

    const connection = new Connection(clusterApiUrl('mainnet-beta'), 'confirmed');
    const tx = new Transaction().add(new TransactionInstruction({
        keys: [{ pubkey: publicKey, isSigner: true, isWritable: false }],
        programId: new PublicKey(MEMO_PROGRAM_ID),
        data: Buffer.from(message, 'utf8')
    }));
    tx.feePayer = publicKey;
    const { blockhash } = await connection.getLatestBlockhash();
    tx.recentBlockhash = blockhash;
    const signed = await signTransaction(tx);
    return Buffer.from(signed.serialize()).toString('base64');
};
